import styled from 'astroturf/react';
import DataGridBaseHeader from './DataGridBaseHeader';
import DataGridBaseColumn from './DataGridBaseColumn';
import DataGridBaseColumns from './DataGridBaseColumns';
import DataGridBaseNoLink from './DataGridBaseNoLink';
import DataGridBaseLink from './DataGridBaseLink';

const Header = styled(DataGridBaseHeader)`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: var(--white);
  z-index: 9999;
`;

const Columns = styled(DataGridBaseColumns)`
  margin: 0 20px 0 20px;
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: sticky;
  top: 80px;
  background-color: var(--ph-gray-100);
  border-radius: var(--ph-border-radius-sm);
  z-index: 1;
  user-select: none;

  &.isStatic {
    top: 0;
    position: relative;
  }
`;

const Column = styled(DataGridBaseColumn)`
  font-size: var(--ph-text-sm);
  color: var(--white);
  flex: 1;
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  &:first-child {
    flex: 0 0 20%;
  }

  &:hover {
    background-color: rgba(var(--black), 0.2);
  }

  & > div {
    padding: 10px;
  }
`;

const EditableColumns = styled('div')`
  margin: 0 20px 0 20px;
  padding: 0 40px 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1;
  user-select: none;
`;

const EditableColumn = styled('div')`
  font-size: var(--ph-text-md);
  line-height: 1.54;
  color: var(--ph-gray-500);
  flex: 1;
  cursor: pointer;
  position: relative;
  white-space: nowrap;

  & > div {
    padding: 7px 3px 8px;
  }
`;

const ColumnIconArrow = styled('div')`
  border: solid var(--white);
  border-width: 0 1px 1px 0;
  padding: 2px;
  transform: rotate(45deg);
  margin: -10px 5px 0 10px;
  display: inline-block;
  width: 0;
  position: relative;
  top: -2px;
`;

const ColumnArrow = styled('span')`
  margin-left: 5px;
  color: var(--white);
`;

const Link = styled(DataGridBaseLink)`
  transition: var(--ph-background-transition);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  position: relative;

  &:hover {
    background-color: rgba(var(--ph-gray-rgb-50), 0.8);
    text-decoration: none;
    border-radius: var(--ph-border-radius-sm);
  }

  &:hover > div[class*='DeleteButtonWrapper'] {
    display: block;
  }

  &.wrapped > div {
    white-space: break-spaces;
  }

  &.wrapped > div > span {
    white-space: nowrap;
    margin-bottom: 5px;
  }

  &.editable {
    cursor: default;

    &:hover {
      background-color: transparent;
    }

    & + & {
      margin-top: -3px;
    }
  }
`;

const NoLink = styled(DataGridBaseNoLink)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0 0 0 20px;
  position: relative;

  &:hover > div[class*='DeleteButtonWrapper'] {
    display: block;
  }

  > div {
    padding: 10px 0;
  }

  &.editable {
    cursor: default;

    > div {
      padding: 0;
    }

    &:nth-child(even) {
      background-color: transparent;
    }

    &:hover {
      background-color: transparent;
    }

    & + & {
      margin-top: -3px;
    }
  }
`;

const Item = styled('div')`
  flex: 1;
  font-size: var(--ph-text-sm);
  padding: 8px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--black);

  &:first-child {
    flex: 0 0 20%;
  }
`;

const EditableItem = styled('div')`
  flex: 1;
  color: rgba(#332d29, 0.7);
  font-size: 1.4rem;
  line-height: 1.43;
  padding: 0;

  label {
    margin: 0;
    padding: 0;
    border-radius: 0;
    background-color: transparent;
    height: 30px;
  }
`;

export default {
  Header,
  Columns,
  Column,
  EditableColumns,
  EditableColumn,
  ColumnIconArrow,
  ColumnArrow,
  Link,
  NoLink,
  Item,
  EditableItem,
};
